// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bae22b66","488":"4e42b234","644":"56ebd24c","977":"7bd98420"}[chunkId] + ".chunk.js";
};